import { API, graphqlOperation } from "@aws-amplify/api";
import axios from "axios";

import { handleError, handleGraphqlError } from "../common/ErrorUtil";

/**
 * HTTPメソッド.
 *
 * @type {object}
 */
export const httpMethod = {
  get: "GET",
  put: "PUT",
  post: "POST",
};

/**
 * GraphQL APIの実行.
 *
 * @param {string} query APIクエリ
 * @param {object} params パラメータ
 * @return {object} レスポンス
 */
export async function executeGraphql(query, params) {
  // APIの実行
  const { data, error } = await API.graphql(
    graphqlOperation(query, params)
  ).catch(handleGraphqlError);
  return { data, error };
}

/**
 * GraphQL APIの繰り返し実行.
 *
 * @param {string} query APIクエリ
 * @param {object} params パラメータ
 * @param {string} key キー名
 * @return {object} レスポンス
 */
export async function executeGraphqlLoop(query, params, key) {
  const response = {
    data: {
      [key]: {
        items: [],
      },
    },
  };

  do {
    // APIの実行
    // eslint-disable-next-line no-await-in-loop
    const { data, error } = await executeGraphql(query, params).catch(
      handleError
    );

    if (error) {
      response.error = error;
      break;
    }

    if (data && data[key]) {
      if (data[key].items && data[key].items.length) {
        response.data[key].items = [
          ...response.data[key].items,
          ...data[key].items,
        ];
      }
      params.nextToken = data[key].nextToken;
    } else {
      params.nextToken = null;
    }

    // nextTokenがnullではない限りループする
  } while (params.nextToken);

  return response;
}

/**
 * REST APIの実行.
 *
 * @param {string} method メソッド
 * @param {string} url URL
 * @param {object} headers ヘッダー
 * @param {object} apiData データ
 * @return {object} レスポンス
 */
export async function executeRest(method, url, headers, apiData) {
  const { error, ...data } = await axios({
    method,
    url,
    headers,
    data: apiData,
  }).catch(handleError);

  return { data, error };
}
